import useApiMutation from '@src/hooks/useApiMutation';
import { User } from '@src/types/User';

export default (userId: string) =>
  useApiMutation<null, User>({
    apiPath: `/users/${userId}`,
    method: 'DELETE',
    useV2API: true,
  });
